import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { isPcsFormControl } from '@app/shared/forms/form-control';
import { isPcsFormGroup } from '@app/shared/forms/form-group';
import { isFormArray, isFormGroup } from '@app/util';
import { ValdrConstraints } from '@app/valdr/models/valdr-constraints';
import * as R from 'ramda';

const getValidators = R.values;

/**
 * Adds validators to all fields of the Angular reactive form according to the Valdr constraints.
 *
 * @template T
 * @param {ValdrConstraints} constraints - valdr constraints
 * @param {T} form - reactive form
 * @return {T} Form with valdr validators
 */
export const withValdr = <T extends AbstractControl = UntypedFormGroup>(constraints: ValdrConstraints, form: T): T => {
  R.forEachObjIndexed((control: AbstractControl, controlName: string) => {
    if (isFormGroup(control)) {
      withValdr(constraints, control);
    } else if (isFormArray(control)) {
      withValdr<UntypedFormArray>(constraints, control);
    } else if (isPcsFormGroup(form)) {
      const propertyName = form.getPropertyName(controlName);

      if (isPcsFormControl(control)) {
        const propertyValidators = constraints[form.getEntityName()];
        if (propertyValidators) {
          control.addValidators(getValidators(propertyValidators[propertyName]));
        }
      }
    }
  }, (form as any).controls);

  return form;
};
